// extracted by mini-css-extract-plugin
export var leftAlign = "_q-2";
export var popper = "_q-0";
export var subtitle = "_q-1";